module.exports = __webpack_public_path__ + "img/individuel.0b46377f.jpg";